/**
 * Login Page
 *
 * Shows welcome message with login button in header.
 * Redirects to home if already authenticated.
 */

import { type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@features/auth';
import { MainLayout } from '@components/layout';
import { ROUTES } from '@utils/constants';

interface LocationState {
  from?: { pathname: string };
}

export function LoginPage(): ReactElement {
  const { isAuthenticated, isLoading, oauthEnabled } = useAuth();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const from = state?.from?.pathname || ROUTES.HOME;

  // If OAuth is disabled (dev mode), redirect to home
  if (!oauthEnabled && !isLoading) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  // Already authenticated - redirect to intended destination
  if (isAuthenticated && !isLoading) {
    return <Navigate to={from} replace />;
  }

  return (
    <MainLayout>
      <div className="login-page">
        <h1 className="login-page__title">Secure Development Platform</h1>
        <p className="login-page__subtitle">
          Code never leaves the cluster.
        </p>
      </div>
    </MainLayout>
  );
}
